export const currencyOptions = [
  { key: 'krw', value: 'krw', text: '₩ KRW' },
  { key: 'usd', value: 'usd', text: '$ USD' }
];
export const columnHeaders = [
  ['MODEL NAME', 'НАЗВАНИЕ ПРОДУКТА', 'NOMBRE DEL PRODUCTO', '名称', 'NOM DU MODÈLE', 'NOME DO PRODUTO'],
  ['COMPOSITION & PACK.UNIT', 'ИНГРЕДИЕНТЫ И УПАКОВКА', 'COMPOSICION Y EMPAQUE', '成分与包装', "COMPOSITION ET UNITÉ D'EMBALLAGE", 'COMPOSIÇÃO & EMBALAGEM'],
  ['R PRICE', 'W PRICE', 'ЦЕНА', 'PRECIO', '价格', 'PRIX', 'PREÇOS'],
  ['PRODUCT DRAWING', 'ВИД', 'IMAGEN DEL PRODUCTO', '产品图片', 'IMAGE DU PRODUIT', 'FOTO DO PRODUTO'],
];

//['MODEL NAME', 'PRODUCT DRAWING', 'COMPOSITION & PACK.UNIT', 'NEEDLE TYPE', 'NEEDLE GAUGE', 'NEEDLE MM', 'THREAD TYPE', 'THREAD USP', 'THREAD MM', 'PRICE', 'DESCRIPTION'];
export const headerTranslations = {
  ru: [
    'Название продукта',
    'Вид',
    'Ингредиенты и упаковка',
    'Тип',
    'Гейдж',
    'MM',
    'Тип',
    'USP',
    'MM',
    'Цена',
    'Описание'
  ],

  sp: [
    'Nombre del producto',
    'Imagen del producto',
    'Composición y empaque',
    'Tipo',
    'Calibre',
    'MM',
    'Tipo',
    'USP',
    'MM',
    'Precio',
    'Descripción'
  ],

  cn: [
    '名称',
    '产品图片',
    '成分与包装',
    '类型',
    '宽度',
    '毫米',
    '类型',
    'USP',
    '毫米',
    '价格',
    '描述'
  ],

  fr: [
    'Nom du modèle',
    'Image du produit',
    'Composition et unité d`emballage',
    'Type',
    'Jauge',
    'MM',
    'Type',
    'USP',
    'MM',
    'Prix',
    'Description'
  ],

  por: [
    'Nome do produto',
    'Foto do produto',
    'Composição & embalagem',
    'Tipo',
    'Medidor',
    'MM',
    'Tipo',
    'USP',
    'MM',
    'Preços',
    'Descrição'
  ]
};
export const headerPriceTranslations = {
  eng: ['from', 'to', 'from'],
  ru: ['от', 'до', 'от'],
  sp: ['de', 'a', 'mas de', 'de'],
  cn: ['零售价', '起', '零售价'],
  fr: ['de', 'à', 'plus de', 'de'],
  por: ['de', 'à', 'a partir de', 'de']
};

export const retailtPrice = {
  eng: 'This is the retail price for purchases with quantity',
  ru: 'Это розничная цена при покупке',
  sp: 'Este es el precio de venta',
  cn: ['零售价', '起', '零售价'],
  fr: 'Ceci est le prix de vente au détail',
  it: 'Questo è il prezzo al dettaglio',
  por: 'Este é o preço de varejo'
};

export const whPrice = {
  eng: 'This is the wholesale price for purchases with quantity',
  ru: 'Это оптовая цена при покупке',
  sp: 'Este es el precio de venta al por mayor',
  cn: ['零售价', '起', '零售价'],
  fr: 'Ceci est le prix de gros',
  it: 'Questo è il prezzo all’ingrosso',
  por: 'Este é o preço de atacado'
};

export const whAddPrice = {
  eng: 'This is the wholesale additional price for purchases with quantity',
  ru: 'Это дополнительная оптовая цена при покупке',
  sp: 'Este es el precio de venta al por mayor',
  cn: ['零售价', '起', '零售价'],
  fr: 'Ceci est le prix de gros',
  it: 'Questo è il prezzo all’ingrosso',
  por: 'Este é o preço de atacado'
};

export const priceTranslation = {
  eng: 'You can purchase from our official distributor',
  ru: 'Вы можете приобрести у нашего официального партнера',
  sp: 'Puede adquirirlo con nuestro distribuidor oficial',
  cn: '',
  fr: 'Produit disponible chez notre distri-buteur'
};

export const myOrderBtn = {
  eng: 'My Orders',
  ru: 'Мои заказы',
  sp: 'Mis pedidos',
  cn: '',
  fr: 'Mes commandes'
};

export const addToCartBtn = {
  eng: 'Add to cart',
  ru: 'Добавить в корзину',
  sp: 'Añadir a la cesta',
  cn: '',
  fr: 'Ajouter au panier'
};

export const addedToCartBtn = {
  eng: 'Added!',
  ru: 'Добавлено!',
  sp: '¡Añadido!',
  cn: '',
  fr: 'Ajouté !'
};

export const sendOrderBtn = {
  eng: 'Send Order',
  ru: 'Отправить заказ',
  sp: 'Enviar un pedido',
  cn: '',
  fr: 'Soumettre une commande'
};

export const emailText = {
  eng: 'A copy of purchasing list will be sent to this email address.',
  ru: 'Копия списка закупок будет отправлена ​​на этот адрес электронной почты.',
  sp: 'Se enviará una copia de la lista de compras a esta dirección de correo electrónico.',
  cn: '',
  fr: `Une copie de la liste d'achat sera envoyée à cette adresse e-mail.`
};

export const submitText = {
  eng: 'You are submitting an order request to your manager.',
  ru: 'Вы отправляете заказ своему менеджеру.',
  sp: 'Estás enviando una solicitud de pedido a tu gerente.',
  cn: '',
  fr: 'Vous soumettez une demande de commande à votre responsable.'
};

export const submitTextExtra = {
  eng: 'Only the products in your cart at the time of the last Send Order click will be included in the request.',
  ru: 'В запрос будут включены только те товары, которые находились в вашей корзине на момент последнего нажатия кнопки «Отправить заказ».',
  sp: 'Sólo se incluirán en la solicitud los productos que estén en su carrito en el momento del último clic en Enviar pedido.',
  cn: '',
  fr: 'Seuls les produits présents dans votre panier au moment du dernier clic sur Envoyer la commande seront inclus dans la demande.'
};

export const itemsAtPriceText = {
  eng: 'items at the price of',
  ru: 'товаров на сумму',
  sp: 'artículos por un valor de',
  cn: '',
  fr: 'articles au prix de'
};

export const summaryText = {
  eng: 'Summary',
  ru: 'Сводка',
  sp: 'Resumen',
  cn: '',
  fr: 'Résumé'
};

export const confirmSendText = {
  eng: 'Yes, send it',
  ru: 'Да, отправить',
  sp: 'Sí, enviarlo',
  cn: '',
  fr: 'Oui, envoyez-le'
};

export const cancelText = {
  eng: 'Cancel',
  ru: 'Отмена',
  sp: 'Cancelar',
  cn: '',
  fr: 'Annuler'
};

export const contactSoonText = {
  eng: 'A sales manager will contact you shortly.',
  ru: 'Менеджер свяжется с вами в ближайшее время.',
  sp: 'Un gerente de ventas se pondrá en contacto con usted en breve.',
  cn: '',
  fr: 'Un responsable commercial vous contactera sous peu.'
};

export const thankYouText = {
  eng: 'Thank you for your order!',
  ru: 'Спасибо за ваш заказ!',
  sp: '¡Gracias por su pedido!',
  cn: '',
  fr: 'Merci pour votre commande !'
};

export const orderCompleted = {
  eng: ['Order Submitted!', 'Your order has been successfully submitted.', 'Please contact your manager to receive a new ordering link.'],
  ru: ['Заказ оформлен!', 'Ваш заказ успешно оформлен.', 'Пожалуйста, свяжитесь с вашим менеджером, чтобы получить новую ссылку для оформления заказа.'],
  sp: ['¡Pedido enviado!', 'Su pedido se ha enviado correctamente.', 'Por favor, contacte a su agente para recibir un nuevo enlace de pedido.'],
  fr: ['Commande enregistrée !', 'Votre commande a été soumise avec succès.', 'Contactez votre responsable pour obtenir un nouveau lien de commande.'],
  it: ['Il suo ordine è stato inviato con successo!', 'Il tuo ordine è stato inviato con successo.', 'Contatta il tuo responsabile per ricevere un nuovo link per effettuare l’ordine.'],
  por: ['Pedido enviado!', 'Seu pedido foi enviado com sucesso.', 'Por favor, entre em contato com seu gerente de vendas para receber um novo link.'],
  cn: ''
};

export const emptyCartText = {
  eng: 'Your cart is empty.',
  ru: 'Ваша корзина пуста.',
  sp: 'Tu carrito está vacío.',
  cn: '',
  fr: 'Votre panier est vide.'
};

export const totalLabel = {
  eng: 'Total',
  ru: 'Итого',
  sp: 'Total',
  cn: '',
  fr: 'Total'
};

export const allowedDepartments = ['Sales Department', 'Cosmetic Brand-Suppuru'];
